import { createAction } from "redux-act";

export const fetchUnitData = createAction<any>("GET_UNIT_DATA");
export const fetchedUnitData = createAction<any>("GET_UNIT_SUCCESS");
